module.exports = {"540102002":"八廓街道","540102003":"吉日街道","540102004":"吉崩岗街道","540102005":"扎细街道","540102006":"公德林街道","540102007":"嘎玛贡桑街道","540102008":"两岛街道","540102009":"金珠西路街道","540102010":"蔡公堂街道","540102011":"夺底街道","540102012":"娘热街道","540102013":"纳金街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540102.json
// module id = 2809
// module chunks = 0